'use client';

import { usePathname } from 'next/navigation';
import dynamic from 'next/dynamic';

const AppFooter = dynamic(() => import('./AppFooter'));

export default function ConditionalFooter() {
  const pathname = usePathname();

  // Hide footer on widget page
  if (pathname === '/widget') {
    return null;
  }

  return <AppFooter />;
}
